import React, { useEffect, useRef, useState } from 'react'

export default function SketchOnTeam({
    selectedTeam,
    toolboxMode,
    handleStartDrawing,
    handleDraw,
    handleStopDrawing,
    teamCanvasVideoRef,
    teamTextCanvasRef,
    teamImageCanvasRef,
    teamDrawCanvasRef,
    teamEraseCanvasRef,
    doErasing,
    teamCompositeCanvasRef,
    isSendingScreenShot
}) {
    const [canvasSize, setCanvasSize] = useState({ width: 0, height: 0 });
    const imageRef = useRef(null);

    useEffect(() => {
        const img = imageRef.current;
        if (img) {
            const updateSize = () => {
                setCanvasSize({ width: img.width, height: img.height });
            };
            img.addEventListener('load', updateSize);
            updateSize();
            return () => img.removeEventListener('load', updateSize);
        }
    }, [selectedTeam]);

    return (
        <div style={{
            width: '100%',
            justifyContent: 'center',
            marginBottom: '20px',
            position: 'relative',
            display: isSendingScreenShot ? 'none' : 'flex'
        }} onMouseDown={(e) => e.stopPropagation()}>
            <img
                ref={imageRef}
                src={selectedTeam.screenshot}
                alt={`${selectedTeam.userTeamName} screenshot`}
                style={{
                    maxWidth: '100%',
                    height: 'auto',
                    minHeight: '200px',
                    objectFit: 'contain'
                }}
                onMouseDown={(e) => e.stopPropagation()}
            />

            {/* Canvas */}
            <canvas
                id="teamCanvasVideoRef"
                ref={teamCanvasVideoRef}
                width={canvasSize.width}
                height={canvasSize.height}
                style={{ position: 'absolute', top: 5, left: 5, zIndex: 1, pointerEvents: 'none' }}
                onMouseDown={(e) => e.stopPropagation()}
            />

            <canvas
                id="teamTextCanvasRef"
                ref={teamTextCanvasRef}
                width={canvasSize.width}
                height={canvasSize.height}
                style={{
                    position: 'absolute',
                    zIndex: toolboxMode === 'text' ? 4 : 2,
                    pointerEvents: toolboxMode === 'text' ? 'auto' : 'none',
                }}
            />

            <canvas
                id="teamImageCanvasRef"
                ref={teamImageCanvasRef}
                width={canvasSize.width}
                height={canvasSize.height}
                style={{
                    position: 'absolute',
                    zIndex: 3,
                    pointerEvents: toolboxMode === 'imageAndIcons' ? 'auto' : 'none',
                }}
            />

            <canvas
                id="teamDrawCanvasRef"
                ref={teamDrawCanvasRef}
                width={canvasSize.width}
                height={canvasSize.height}
                onMouseDown={handleStartDrawing}
                onMouseMove={handleDraw}
                onMouseUp={handleStopDrawing}
                onMouseLeave={handleStopDrawing}
                style={{
                    position: 'absolute',
                    zIndex: 4,
                    pointerEvents: toolboxMode === 'draw' ? 'auto' : 'none',
                }}
            />

            <canvas
                id="teamEraseCanvasRef"
                ref={teamEraseCanvasRef}
                width={canvasSize.width}
                height={canvasSize.height}
                onMouseDown={handleStartDrawing}
                onMouseMove={doErasing}
                onMouseUp={handleStopDrawing}
                onMouseLeave={handleStopDrawing}
                style={{
                    position: 'absolute',
                    zIndex: toolboxMode === 'erase' ? 4 : 2,
                    pointerEvents: toolboxMode === 'erase' ? 'auto' : 'none',
                }}
            />

            <canvas
                id="teamCompositeCanvasRef"
                ref={teamCompositeCanvasRef}
                width={canvasSize.width}
                height={canvasSize.height}
                style={{ position: 'absolute', zIndex: 5, pointerEvents: 'none' }}
                onMouseDown={(e) => e.stopPropagation()}
            />
        </div>
    )
}